import * as bootstrap from 'bootstrap';
import { pannellum } from './pannellum';

// Define the interface of a scene.
interface Scene {
  type: 'equirectangular';
  hotSpotDebug?: boolean; // This should only be used in development for finding the correct yaw and pitch.
  panorama: URL;
  hotSpots: Hotspot[];
  autoLoad: true;
}
// Define the interface of a hotspot.
interface Hotspot {
  type: 'info' | 'scene';
  id: string;
  pitch: number;
  yaw: number;
  text: string;
  cssClass: string;
  clickHandlerFunc: Function;
  clickHandlerArgs: {
    afterCompletion?: {
      create?: string;
      view?: string;
      hide?: boolean;
    };
    startingAction?: number; // Only if there is an action to start with.
    id: string;
  };
  sceneId?: string; // Only when it's a scene hotspot.
}

// Creating the action interface, an action can be of three types: text, video or question.
interface Action {
  type: 'text' | 'video' | 'question' | 'redirect';
  next?: number;
}

// Creating the text action interface.
interface TextAction extends Action {
  type: 'text';
  content: string;
  img?: string;
}

// Creating the video action interface.
interface VideoAction extends Action {
  type: 'video';
  vimeoId: number;
}

// Creating the question action interface.
interface QuestionAction extends Action {
  type: 'question';
  question: string;
  answers: {
    answer: string;
    next?: number;
  }[];
}

// Creating the redirect action interface.
interface RedirectAction extends Action {
  type: 'redirect';
  url: string;
}
const startingScene = 'Ruimte_1'; 
      document.getElementById('phone').addEventListener('click', function() {
        window.open('tel:123-456-7890', '_blank');
      });
    
      document.getElementById('whatsapp').addEventListener('click', function() {
        window.open('https://wa.me/0031612345678', '_blank');
      });
    
      document.getElementById('email').addEventListener('click', function() {
        window.open('mailto:info@purplesquirreleffect.nl', '_blank');
      });
    
      document.getElementById('website').addEventListener('click', function() {
        window.open('https://purplesquirreleffect.nl/', '_blank');
      });
    
      document.getElementById('form').addEventListener('click', function() {
        window.open('https://purplesquirreleffect.nl/contact', '_blank');
      });
    const scenes : { [sceneName: string]: Scene } = {"Ruimte_1":{"type":"equirectangular","panorama":new URL('../Assets/360/Ruimte_1.jpg',import.meta.url),"hotSpots":[{"id":"Ruimte_1_5","cssClass":"custom-hotspot Ruimte_1_5","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_5","startingAction":0},"pitch":180,"yaw":170,"type":"info","text":"<b>Work-Life Balance</b>"},{"id":"Ruimte_1_4","cssClass":"custom-hotspot Ruimte_1_4","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_4","startingAction":1},"pitch":180,"yaw":130,"type":"info","text":"<b>Dit zijn wij</b>"},{"id":"Ruimte_1_3","cssClass":"custom-hotspot Ruimte_1_3","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_3","startingAction":2},"pitch":180,"yaw":90,"type":"info","text":"<b>Werksfeer vinden wij belangrijk</b>"},{"id":"Ruimte_1_2","cssClass":"custom-hotspot Ruimte_1_2","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_2","startingAction":3},"pitch":170,"yaw":45,"type":"info","text":"<b>Enthousiast?!</b><br> Meer over Purple Squirrel Effect"},{"id":"Ruimte_1_1","cssClass":"custom-hotspot Ruimte_1_1","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_1","startingAction":8},"pitch":170,"yaw":-150,"type":"info","text":"<b>Sollicitatietips</b><br>Solliciteren als de beste!"},{"id":"Ruimte_1_0","cssClass":"custom-hotspot Ruimte_1_0","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_0","startingAction":9},"pitch":0,"yaw":0,"type":"info","text":""}],"autoLoad":true,"yaw":-45,"pitch":0}};
        const hotspots : {[ID : string] : Hotspot} = {"Ruimte_1_5":{"id":"Ruimte_1_5","cssClass":"custom-hotspot Ruimte_1_5","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_5","startingAction":0},"pitch":180,"yaw":170,"type":"info","text":"<b>Work-Life Balance</b>"},"Ruimte_1_4":{"id":"Ruimte_1_4","cssClass":"custom-hotspot Ruimte_1_4","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_4","startingAction":1},"pitch":180,"yaw":130,"type":"info","text":"<b>Dit zijn wij</b>"},"Ruimte_1_3":{"id":"Ruimte_1_3","cssClass":"custom-hotspot Ruimte_1_3","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_3","startingAction":2},"pitch":180,"yaw":90,"type":"info","text":"<b>Werksfeer vinden wij belangrijk</b>"},"Ruimte_1_2":{"id":"Ruimte_1_2","cssClass":"custom-hotspot Ruimte_1_2","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_2","startingAction":3},"pitch":170,"yaw":45,"type":"info","text":"<b>Enthousiast?!</b><br> Meer over Purple Squirrel Effect"},"Ruimte_1_1":{"id":"Ruimte_1_1","cssClass":"custom-hotspot Ruimte_1_1","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_1","startingAction":8},"pitch":170,"yaw":-150,"type":"info","text":"<b>Sollicitatietips</b><br>Solliciteren als de beste!"},"Ruimte_1_0":{"id":"Ruimte_1_0","cssClass":"custom-hotspot Ruimte_1_0","clickHandlerFunc":hotspotClickHandler,"clickHandlerArgs":{"id":"Ruimte_1_0","startingAction":9},"pitch":0,"yaw":0,"type":"info","text":""}};
        const actions : (TextAction | VideoAction | QuestionAction | RedirectAction)[] = [{"type":"video","vimeoId":836886418},{"type":"video","vimeoId":836886438},{"type":"video","vimeoId":836886459},{"type":"question","question":"<h1 id=\"wat-werkt-voor-jou-het-beste\">Wat werkt voor jou het beste?</h1>\n","answers":[{"answer":"Plan Pitch met Mitch","next":4},{"answer":"Bel ons op telefoonnummer +31 (0) 85 782 1400","next":5},{"answer":"Mail ons","next":6},{"answer":"Terug naar de omgeving"}]},{"type":"redirect","url":"https://purplesquirreleffect.nl/contact"},{"type":"redirect","url":"https://tinyurl.com/38j76jr8"},{"type":"redirect","url":"https://tinyurl.com/k5z96wy9"},{"type":"question","question":"<h1 id=\"wat-werkt-voor-jou-het-beste\">Wat werkt voor jou het beste?</h1>\n","answers":[{"answer":"Plan Pitch met Mitch","next":4},{"answer":"Bel ons op telefoonnummer +31 (0) 85 782 1400","next":5},{"answer":"Mail ons","next":6},{"answer":"Terug naar de omgeving"}]},{"type":"text","content":"<h1 id=\"sollicitatietips\">Sollicitatietips</h1>\n<ul>\n<li><h6 id=\"bedenk-van-tevoren-wat-je-over-jezelf-kunt-en-wil-vertellen-met-een-goede-voorbereiding-bespaar-je-jezelf-een-hoop-onnodige-stress\">Bedenk van tevoren wat je over jezelf kunt en wil vertellen. Met een goede voorbereiding bespaar je jezelf een hoop onnodige stress.</h6>\n</li>\n<li><h6 id=\"zet-je-karaktereigenschappen-op-een-rijtje-zowel-je-sterke-als-je-minder-sterke-eigenschappen-dat-laatste-wordt-nog-wel-eens-vergeten-terwijl-je-bewust-zijn-van-je-minder-sterke-eigenschappen-en-nagedacht-hebben-over-hoe-je-die-kan-verbeteren-juist-kracht-en-drang-tot-zelfverbetering-uitstraalt\">Zet je karaktereigenschappen op een rijtje, zowel je sterke als je minder sterke eigenschappen. Dat laatste wordt nog wel eens vergeten, terwijl je bewust zijn van je minder sterke eigenschappen en nagedacht hebben over hoe je die kan verbeteren juist kracht en drang tot zelfverbetering uitstraalt!</h6>\n</li>\n<li><h6 id=\"hou-altijd-in-je-achterhoofd-dat-je-tijdens-het-sollicitatiegesprek-in-de-eerste-plaats-duidelijk-wil-maken-waarom-wij-jou-zouden-moeten-aannemen\">Hou altijd in je achterhoofd dat je tijdens het sollicitatiegesprek in de eerste plaats duidelijk wil maken waarom wij jou zouden moeten aannemen.</h6>\n</li>\n<li><h6 id=\"zoek-op-internet-eens-naar-de-meest-gestelde-vragen-bij-een-sollicitatiegesprek-en-kijk-of-je-daar-al-een-antwoord-op-kunt-bedenken-op-die-manier-hoef-je-er-tijdens-het-gesprek-niet-meer-over-na-te-denken\">Zoek op internet eens naar de meest gestelde vragen bij een sollicitatiegesprek en kijk of je daar al een antwoord op kunt bedenken. Op die manier hoef je er tijdens het gesprek niet meer over na te denken.</h6>\n</li>\n</ul>\n"},{"type":"question","question":"<h1 id=\"waar-krijg-jij-het-meeste-energie-van\">Waar krijg jij het meeste energie van?</h1>\n","answers":[{"answer":"Als sparringpartner van de hiring managers meedenken over het profiel waar we naar op zoek zijn"},{"answer":"Nieuwe kandidaten zoeken en enthousiasmeren voor een rol als adviseur of accountant"}]},{"type":"question","question":"<h1 id=\"waar-krijg-jij-het-meeste-energie-van\">Waar krijg jij het meeste energie van?</h1>\n","answers":[{"answer":"Als sparringpartner van de hiring managers meedenken over het profiel waar we naar op zoek zijn"},{"answer":"Nieuwe kandidaten zoeken en enthousiasmeren voor een rol als adviseur of accountant"}]}];
let viewer = pannellum.viewer('panorama', {
  showControls: false,
  default: {
    firstScene: startingScene,
  },
  scenes: scenes,
});

// This function is called when the hotspot is clicked. It handles four things, the startingAction, and the view, create and hide options.
function hotspotClickHandler(
  clickEvent: PointerEvent,
  hotspotArguments: Hotspot['clickHandlerArgs'],
) {
  // Create a new bootstrap modal.
  let modal = new bootstrap.Modal('#actionModal');
  // Check if the hotspot has a startingAction.
  if (hotspotArguments['startingAction'] != undefined) {
    if (hotspotArguments['startingAction']['type'] != 'redirect') {
      modalParser(actions[hotspotArguments['startingAction']]);
      modal.toggle();
    } else {
      // Open in a new tab:
      window.open(hotspotArguments['startingAction']['url'], '_blank');
    }
  }
  // In this order, check the arguments['afterCompletion'] for a create, hide and view value.
  // Then add an event listener that runs once to the modal, if the modal is hidden, run the afterCompletion functions.
  if (hotspotArguments['afterCompletion']['create'] != undefined) {
    // Get the element that holds the action modal.
    let actionModal = document.getElementById('actionModal');
    actionModal.addEventListener(
      'hidden.bs.modal',
      function () {
        viewer.addHotSpot(
          hotspots[hotspotArguments['afterCompletion']['create']],
        );
      },
      { once: true },
    );
  }
  if (hotspotArguments['afterCompletion']['hide'] != undefined) {
    let actionModal = document.getElementById('actionModal');
    actionModal.addEventListener(
      'hidden.bs.modal',
      function () {
        // Remove the hotspot.
        viewer.removeHotSpot(hotspotArguments.id);
      },
      { once: true },
    );
  }
  if (hotspotArguments['afterCompletion']['view'] != undefined) {
    let hotspotToView = hotspots[hotspotArguments['afterCompletion']['view']];
    let actionModal = document.getElementById('actionModal');
    actionModal.addEventListener(
      'hidden.bs.modal',
      function () {
        // Change the scene.
        viewer.lookAt(hotspotToView.pitch, hotspotToView.yaw);
      },
      { once: true },
    );
  }
}

// This function receives the action object and modifies the modal content.
async function modalParser(
  action: TextAction | VideoAction | QuestionAction | RedirectAction,
) {
  let actionModal = document.getElementById('actionModal');
  // Get the #actionModal// If the action object is a Redirect, open the url in a new tab, hide the modal and stop executing the function.
  if (action['type'] == 'redirect') {
    window.open(action['url'], '_blank');
    // If there is an action modal, get the bootstrap modal instance.
    setTimeout(() => {
      let actionModal = document.getElementById('actionModal');
      if (actionModal != null) {
        let modal = bootstrap.Modal.getInstance(actionModal);
        if (modal != null) {
          modal.hide();
        }
      }
    }, 1000);
    return;
  }
  let modalBody = actionModal.querySelector('.modal-body');
  let modalDialog = actionModal.querySelector('.modal-dialog');
  modalBody.innerHTML = '';
  modalBody.classList.remove('video-div', 'modal-lg', 'modal-xl');
  let icon = document.createElement('i');
  icon.classList.add('bi', 'bi-arrow-right-short');
  // We check for the type of the action object.
  switch (action['type']) {
    // If the action object is a text, create a new div with the class text-wrapper and add it to the modal-body.
    case 'text':
      // Add the 'modal-lg' class to the modal-dialog.
      modalDialog.classList.add('modal-lg');
      let textWrapper = document.createElement('div');
      textWrapper.classList.add('text-wrapper');
      modalBody.appendChild(textWrapper);
      // Insert the content of the action object into the textWrapper.
      textWrapper.innerHTML = action['content'];
      // Check if there is an img in the action object.
      if (action['img'] != undefined) {
        // Create a new img element and add it to the textWrapper.
        let img = document.createElement('img');
        img.src = action['img'];
        textWrapper.appendChild(img);
      }
      // Add a button to the modal-body.
      let button = document.createElement('button');
      button.classList.add('btn', 'btn-primary');
      button.innerHTML = 'Volgende';
      button.appendChild(icon);
      actionModal.querySelector('.modal-body').appendChild(button);
      // Check if the action object has a next property.
      if (action['next'] == undefined) {
        // If the action object doesn't have a next property, add the dismiss attribute to the button.
        button.dataset.bsDismiss = 'modal';
      } else {
        // Add an event listener to the button, which only runs once.
        button.addEventListener(
          'click',
          (event) => {
            modalParser(actions[action['next']]);
          },
          { once: true },
        );
      }
      break;
    case 'video':
      // Adding appropriate classes for styling.
      modalDialog.classList.add('modal-xl');
      modalBody.classList.add('video-div');
      // Create a button and add it to the modal-body.
      let closeButton = document.createElement('button');
      closeButton.classList.add('btn-close', 'btn-close-white');
      closeButton.dataset.ariaLabel = 'Close';
      // Add a right-arrow icon to the button.
      modalBody.appendChild(closeButton);
      // Create a div with the class video-wrapper and add it to the modal-body.
      let videoWrapper = document.createElement('div');
      videoWrapper.classList.add('video-wrapper');
      modalBody.appendChild(videoWrapper);
      // Create an iframe and add it to the videoWrapper.
      let iframe = document.createElement('iframe');
      // Set the appropriate attributes for the iframe.
      iframe.src = `https://player.vimeo.com/video/${action['vimeoId']}?title=0&amp;byline=0&amp;portrait=0&amp;autoplay=1&amp;dnt=1`;
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      videoWrapper.appendChild(iframe);
      // Add an event listener to the modal, which only runs once. When the modal is closed, the iframe should be removed.
      actionModal.addEventListener(
        'hidden.bs.modal',
        function () {
          iframe.remove();
        },
        { once: true },
      );
      // Check if the action object has a next property.
      if (action['next'] == undefined) {
        // If the action object doesn't have a next property, add the dismiss attribute to the button.
        closeButton.dataset.bsDismiss = 'modal';
      } else {
        // Add an event listener to the button, which only runs once.
        closeButton.addEventListener(
          'click',
          (event) => {
            modalParser(actions[action['next']]);
          },
          { once: true },
        );
      }
      break;
    case 'question':
      modalDialog.classList.add('modal-lg');
      // Create a new div with class 'question-wrapper' and add it to the modal-body.
      let questionWrapper = document.createElement('div');
      questionWrapper.classList.add('question-wrapper');
      modalBody.appendChild(questionWrapper);
      // Insert the content of the question into the questionWrapper.
      questionWrapper.innerHTML = action['question'];
      // Create a new form and add it to the questionWrapper.
      let form = document.createElement('form');
      // Add a div with class 'd-grid gap-2' to the form.
      let dGrid = document.createElement('div');
      dGrid.classList.add('d-grid', 'gap-2');
      form.appendChild(dGrid);
      questionWrapper.appendChild(form);
      // Loop over the answers and create a new button for each answer.
      action['answers'].forEach((answer, index) => {
        // Create the input.
        let input: HTMLInputElement = document.createElement('input');
        input.type = 'radio';
        // If the answer has a next value, add the value to the input, else set it to no-next.
        if (answer['next'] != undefined) {
          input.value = answer['next'].toString();
        } else {
          input.value = 'no-next';
        }
        input.name = 'answer';
        input.classList.add('btn-check', 'form-button');
        input.id = `opt-${index}`;
        input.autocomplete = 'off';
        // Create the label.
        let label = document.createElement('label');
        label.classList.add('btn', 'btn-outline-primary');
        label.htmlFor = `opt-${index}`;
        // Create the icons.
        let icon = document.createElement('i');
        let icon2 = document.createElement('i');
        icon.classList.add('bi', 'bi-arrow-right-short');
        icon2.classList.add('bi', 'bi-check');
        // Create the span.
        let span = document.createElement('span');
        span.innerHTML = answer['answer'];
        // Append the icon and span to the label.
        label.appendChild(icon);
        label.appendChild(icon2);
        label.appendChild(span);
        // Append the input and label to the dGrid.
        dGrid.appendChild(input);
        dGrid.appendChild(label);
      });
      // Create a button and add it to the form.
      let submitButton = document.createElement('button');
      submitButton.classList.add('btn', 'btn-primary');
      submitButton.type = 'submit';
      submitButton.innerHTML = 'Verder';
      // Add a right-arrow icon to the button.
      submitButton.appendChild(icon);
      form.appendChild(submitButton);
      // Add an event listener to the form.
      form.addEventListener('submit', (event) => {
        // Prevent the default action of the form.
        event.preventDefault();
        // Get the value of the checked radio button.
        let checked: HTMLInputElement = document.querySelector(
          'input[name="answer"]:checked',
        );
        // Check if the checked radio button has a value.
        if (checked.value == 'no-next') {
          let modal = bootstrap.Modal.getInstance(actionModal);
          // If the checked radio button doesn't have a value, close the modal.
          modal.toggle();
        } else {
          // If the checked radio button has a value, call the modalParser function with the next action.
          modalParser(actions[parseInt(checked.value)]);
        }
      });
      break;
  }
}
// If watched from mobile, zoom in completely.
if (window.innerWidth < 768) {
    viewer.setHfov(0);
}
document.getElementById('fullscreen').addEventListener('click', function(e) {
  viewer.toggleFullscreen();
});
document.getElementById('home').addEventListener('click', function(e) {
  viewer.loadScene(startingScene);
});
document.getElementById('bolt').addEventListener('click', function(e) {
  let conversionOptions = document.querySelector('.conversion-options');
  conversionOptions.classList.toggle('open');
});viewer.on('load', function() {if (viewer.getScene() == 'Ruimte_1') {document.getElementsByClassName('Ruimte_1_0')[0].click();}});